import Vue from "vue";
import VueRouter from "vue-router";
import Router from "vue-router";
import Home from "@/views/Home";
import AboutUS from "@/views/AboutUS";
import JoinUS from "@/views/JoinUS";

Vue.use(VueRouter);
Vue.use(Router);
// 捕获导航异常
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    // 忽略导航到相同路由的错误
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

export default new Router({
  routes: [
    {
      path: "/",
      name: "",
      component: Home,
    },
    {
      path: "/Home",
      name: "Home",
      component: Home,
    },
    {
      path: "/SmartFactory",
      name: "SmartFactory",
      component: () => import("@/views/SmartFactory/index"),
    },
    {
      path: "/Robot",
      name: "Robot",
      component: () => import("@/views/Robot/index"),
    },
    {
      path: "/DigitalHuman/Mobile",
      name: "Mobile",
      component: () => import("@/views/DigitalHuman/mobile"),
    },
    {
      path: "/DigitalHuman/Holography",
      name: "Holography",
      component: () => import("@/views/DigitalHuman/holography"),
    },
    {
      path: "/DigitalHuman/Phone",
      name: "Phone",
      component: () => import("@/views/DigitalHuman/phone"),
    },
    {
      path: "/AboutUS",
      name: "AboutUS",
      component: AboutUS,
    },
    {
      path: "/JoinUS",
      name: "JoinUS",
      component: JoinUS,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js